// This module handles accordion rendering, filter UI, and product display

(function() {
  'use strict';

  window.PB_renderAccordions = function(state, config) {
    const container = document.getElementById('pbAccordions');

    const html = config.collections
      .filter(collection => !collection.hidden)
      .map(collection => {
        // Special handling for info section
        if (collection.type === 'info') {
          const isExpanded = state.expandedAccordion === collection.id;
          return `
            <div class="pb-accordion-item">
              <div class="pb-accordion-header" onclick="pbToggleAccordion('${collection.id}')">
                <div class="pb-accordion-title">
                  <i class="fas fa-info-circle" style="color: #c9a55a; margin-right: 12px; font-size: 28px;"></i>
                  ${collection.name}
                </div>
                <i class="fas fa-chevron-down pb-accordion-icon ${isExpanded ? 'expanded' : ''}"></i>
              </div>
              <div class="pb-accordion-content ${isExpanded ? 'expanded' : ''}" id="accordion-${collection.id}">
                <div class="pb-accordion-body" style="padding: 20px;">
                  <div style="color: #1a1a1a; line-height: 1.6;">
                    <ul style="list-style: none; padding: 0; margin: 0;">
                      <li style="margin-top: 25px; padding: 15px; background: #fff3cd; border-left: 4px solid #c9a55a; border-radius: 4px;">
                        <strong style="color: #856404;">Bundle Discount Details:</strong><br>
                        <div style="margin-top: 10px; color: #856404;">
                          • <strong>2 pieces</strong>: 5% | <strong>3 pieces</strong>: 7% | <strong>4–5 pieces</strong>: 10% | <strong>6+ pieces</strong>: 12%<br>
                          • Items must be from <strong>different categories</strong><br>
                          • <strong>Plumbing</strong> items do not count toward the bundle<br>
                          • <strong>Promo</strong> items: 12% off original price (6+ items only)
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          `;
        }

        const options = state.filterOptions[collection.id];

        if (!options) {
          return `
            <div class="pb-accordion-item">
              <div class="pb-accordion-header" style="opacity: 0.5; cursor: not-allowed;">
                <div class="pb-accordion-title">${collection.name}</div>
                <span style="color: #666; font-size: 0.85rem;">No products found</span>
              </div>
            </div>
          `;
        }

        const isSelected = state.selections.some(s => s.productClassId === collection.id && s.selectedProducts?.length > 0);
        const isExpanded = state.expandedAccordion === collection.id;

        return `
          <div class="pb-accordion-item">
            <div class="pb-accordion-header ${isSelected ? 'selected' : ''}" onclick="pbToggleAccordion('${collection.id}')">
              <div class="pb-accordion-title">
                ${collection.icon ? `<img src="${collection.icon}" alt="${collection.name}" style="width: 32px; height: 32px; margin-right: 10px; filter: brightness(0);">` : ''}
                ${isSelected ? '<i class="fas fa-check-circle" style="color: #c9a55a; margin-right: 8px;"></i>' : ''}
                ${collection.name}
              </div>
              <i class="fas fa-chevron-down pb-accordion-icon ${isExpanded ? 'expanded' : ''}"></i>
            </div>
            <div class="pb-accordion-content ${isExpanded ? 'expanded' : ''}" id="accordion-${collection.id}">
              <div class="pb-accordion-body">
                ${window.PB_renderFilters(collection.id, options, state)}
              </div>
            </div>
          </div>
        `;
      }).join('');

    container.innerHTML = html;
  };

  window.PB_renderSingleAccordion = function(classId, state) {
    const accordionContent = document.getElementById(`accordion-${classId}`);
    if (!accordionContent) {
      // Accordion doesn't exist yet, fall back to full render
      window.PB_renderAccordions(state, window.PB_CONFIG);
      return;
    }

    const options = state.filterOptions[classId];
    if (!options) return;

    const accordionBody = accordionContent.querySelector('.pb-accordion-body');
    if (accordionBody) {
      accordionBody.innerHTML = window.PB_renderFilters(classId, options, state);
    }
  };

  window.PB_renderFilters = function(classId, options, state) {
    const selection = state.productSelections[classId] || {};
    let html = '';

    // Category-specific filter rendering
    html = renderCategoryFilters(classId, options, selection);

    // Validation and required filters check
    const { allSelected, missing } = validateFilters(classId, options, selection);

    if (!allSelected && missing.length > 0) {
      html += `
        <div style="padding: 15px; background: #fff3cd; border: 1px solid #ffc107; border-radius: 6px; margin: 15px 0; color: #856404;">
          <i class="fas fa-exclamation-triangle" style="margin-right: 8px; color: #ffc107;"></i>
          <strong>Please select:</strong> ${missing.join(', ')}
        </div>
      `;
    }

    html += `<button class="pb-reset-class-btn" onclick="pbResetClass('${classId}')">Reset Filters</button>`;

    // Show filtered products if all required filters are selected
    if (allSelected) {
      html += renderFilteredProducts(classId, state);
    }

    return html;
  };

 
  function renderCategoryFilters(classId, options, selection) {
    let html = '';

    if (classId === 'ranges') {
      html = renderRangesFilters(options, selection, classId);
    } else if (classId === 'rangetops') {
      html = renderRangetopsFilters(options, selection, classId);
    } else if (classId === 'hoods') {
      html = renderHoodsFilters(options, selection, classId);
    } else if (classId === 'dishwashers') {
      html = renderDishwashersFilters(options, selection, classId);
    } else if (classId === 'refrigerators') {
      html = renderRefrigeratorsFilters(options, selection, classId);
    } else if (classId === 'microwaves') {
      html = renderMicrowavesFilters(options, selection, classId);
    } else if (classId === 'wall-ovens') {
      html = renderWallOvensFilters(options, selection, classId);
    } else if (classId === 'under-counter-refrigeration') {
      html = renderUnderCounterFilters(options, selection, classId);
    } else if (classId === 'column-refrigerators') {
      html = renderColumnRefrigeratorsFilters(options, selection, classId);
    } else if (classId === 'plumbing') {
      html = renderPlumbingFilters(options, selection, classId);
    }

    return html;
  }

  function renderFilterSelect(label, isRequired, hasValue, options, selectedValue, onChange, valueField = 'id') {
    const requiredMark = isRequired && !hasValue ? '<span style="color: #d32f2f;">*</span>' : '';
    return `
      <div class="pb-filter-group">
        <label class="pb-filter-label">${label} ${requiredMark}</label>
        <select class="pb-filter-select" onchange="${onChange}">
          <option value="">Select ${label}</option>
          ${options.map(opt => {
            const value = valueField === 'name' ? opt : (opt.id || opt);
            const name = opt.name || opt;
            const isSelected = (valueField === 'name' ? selectedValue === name : selectedValue === opt.id) ? 'selected' : '';
            return `<option value="${value}" ${isSelected}>${name}</option>`;
          }).join('')}
        </select>
      </div>
    `;
  }

  // Category-specific filter renderers
  function renderRangesFilters(options, selection, classId) {
    let html = '';

    // Fuel Type
    html += renderFilterSelect('Fuel Type', true, selection.selectedFuelTypeId,
      options.fuelTypes, selection.selectedFuelTypeId,
      `pbHandleFuelTypeChange('${classId}', this.value)`);

    // Filter sizes based on fuel type
    let availableSizes = options.sizes;
    const selectedFuelType = selection.selectedFuelTypeId ?
      options.fuelTypes?.find(f => f.id === selection.selectedFuelTypeId) : null;

    if (selectedFuelType) {
      if (selectedFuelType.name === 'Dual Fuel') availableSizes = ['24 Inch', '30 Inch', '36 Inch', '48 Inch', '60 Inch'];
      else if (selectedFuelType.name === 'All Gas') availableSizes = ['24 Inch', '30 Inch', '36 Inch', '48 Inch'];
      else if (selectedFuelType.name === 'Induction') availableSizes = ['30 Inch', '36 Inch'];
    }

    // Size
    html += renderFilterSelect('Size', true, selection.selectedSize,
      availableSizes, selection.selectedSize,
      `pbHandleSizeChange('${classId}', this.value)`, 'name');

    // Finish
    html += renderFilterSelect('Finish', true, selection.selectedFinishId,
      options.finishes, selection.selectedFinishId,
      `pbHandleFinishChange('${classId}', this.value)`);

    // Accent (Optional)
    html += renderFilterSelect('Accent Finish (Optional)', false, true,
      options.accentFinishes, selection.selectedAccentFinishId,
      `pbHandleAccentFinishChange('${classId}', this.value)`);

    // Handle Type (Optional)
    html += renderFilterSelect('Handle Type (Optional)', false, true,
      options.handleTypes, selection.selectedHandleTypeId,
      `pbHandleHandleTypeChange('${classId}', this.value)`);

    return html;
  }

  function renderRangetopsFilters(options, selection, classId) {
    let html = '';

    // Type
    html += renderFilterSelect('Type', true, selection.selectedRangetopTypeId,
      options.rangetopTypes, selection.selectedRangetopTypeId,
      `pbHandleRangetopTypeChange('${classId}', this.value)`);

    // Filter sizes
    let availableSizes = options.sizes;
    const selectedType = selection.selectedRangetopTypeId ?
      options.rangetopTypes?.find(t => t.id === selection.selectedRangetopTypeId) : null;

    if (selectedType) {
      if (selectedType.name === 'Range Top') availableSizes = ['30 Inch', '36 Inch', '48 Inch'];
      else if (selectedType.name === 'Drop In') availableSizes = ['30 Inch', '36 Inch'];
    }

    // Size
    html += renderFilterSelect('Size', true, selection.selectedSize,
      availableSizes, selection.selectedSize,
      `pbHandleSizeChange('${classId}', this.value)`, 'name');

    // Finish
    html += renderFilterSelect('Finish', true, selection.selectedFinishId,
      options.finishes, selection.selectedFinishId,
      `pbHandleFinishChange('${classId}', this.value)`);

    // Accents (Optional)
    html += renderFilterSelect('Accents (Optional)', false, true,
      options.accentFinishes, selection.selectedAccentFinishId,
      `pbHandleAccentFinishChange('${classId}', this.value)`);

    return html;
  }

  function renderHoodsFilters(options, selection, classId) {
    let html = '';

    // Mount Type
    html += renderFilterSelect('Mount Type', true, selection.selectedMountTypeId,
      options.mountTypes, selection.selectedMountTypeId,
      `pbHandleMountTypeChange('${classId}', this.value)`);

    // Filter sizes
    let availableSizes = options.sizes;
    const selectedMount = selection.selectedMountTypeId ?
      options.mountTypes?.find(m => m.id === selection.selectedMountTypeId) : null;

    if (selectedMount) {
      if (selectedMount.name === 'Wall Mount') availableSizes = ['24 Inch', '30 Inch', '36 Inch', '48 Inch', '60 Inch'];
      else if (selectedMount.name === 'Island Mount') availableSizes = ['30 Inch', '36 Inch', '48 Inch', '60 Inch'];
      else if (selectedMount.name === 'Under Cabinet') availableSizes = ['30 Inch', '36 Inch', '42 Inch', '48 Inch', '60 Inch'];
      else if (selectedMount.name === 'Insert') availableSizes = ['28 Inch', '34 Inch', '40 Inch', '46 Inch'];
    }

    // Size
    html += renderFilterSelect('Size', true, selection.selectedSize,
      availableSizes, selection.selectedSize,
      `pbHandleSizeChange('${classId}', this.value)`, 'name');

    // Finish
    html += renderFilterSelect('Finish', true, selection.selectedFinishId,
      options.finishes, selection.selectedFinishId,
      `pbHandleFinishChange('${classId}', this.value)`);

    // Accent (Optional)
    html += renderFilterSelect('Accent Finish (Optional)', false, true,
      options.accentFinishes, selection.selectedAccentFinishId,
      `pbHandleAccentFinishChange('${classId}', this.value)`);

    return html;
  }

  function renderDishwashersFilters(options, selection, classId) {
    let html = '';

    // Panel Type
    html += renderFilterSelect('Panel Type', true, selection.selectedPanelTypeId,
      options.panelTypes, selection.selectedPanelTypeId,
      `pbHandlePanelTypeChange('${classId}', this.value)`);

    const selectedPanelType = selection.selectedPanelTypeId ?
      options.panelTypes?.find(p => p.id === selection.selectedPanelTypeId) : null;

    // Size
    let availableSizes = ['18 Inch', '24 Inch'];
    html += renderFilterSelect('Size', true, selection.selectedSize,
      availableSizes, selection.selectedSize,
      `pbHandleSizeChange('${classId}', this.value)`, 'name');

    // Finish, Accent only for Panel Included or Dishwasher Panels
    const showFinishFilters = selectedPanelType && (selectedPanelType.name === 'Panel Included' || selectedPanelType.name === 'Dishwasher Panels');

    if (showFinishFilters) {
      html += renderFilterSelect('Finish', true, selection.selectedFinishId,
        options.finishes, selection.selectedFinishId,
        `pbHandleFinishChange('${classId}', this.value)`);

      html += renderFilterSelect('Accent Finish (Optional)', false, true,
        options.accentFinishes, selection.selectedAccentFinishId,
        `pbHandleAccentFinishChange('${classId}', this.value)`);
    }

    // Handle Type (always)
    html += renderFilterSelect('Handle Type (Optional)', false, true,
      options.handleTypes, selection.selectedHandleTypeId,
      `pbHandleHandleTypeChange('${classId}', this.value)`);

    return html;
  }

  function renderRefrigeratorsFilters(options, selection, classId) {
    let html = '';

    // Refrigerator Type
    html += renderFilterSelect('Refrigerator Type', true, selection.selectedRefrigeratorTypeId,
      options.refrigeratorTypes, selection.selectedRefrigeratorTypeId,
      `pbHandleRefrigeratorTypeChange('${classId}', this.value)`);

    const selectedType = selection.selectedRefrigeratorTypeId ?
      options.refrigeratorTypes?.find(r => r.id === selection.selectedRefrigeratorTypeId) : null;

    // Filter sizes
    let availableSizes = options.sizes;
    if (selectedType) {
      if (selectedType.name === 'Counter Depth' || selectedType.name === 'Standard Depth') availableSizes = ['36 Inch'];
      else if (selectedType.name === 'Built In Refrigeration') availableSizes = ['30 Inch', '36 Inch', '60 Inch', '72 Inch'];
      else if (selectedType.name === 'Column Wine' || selectedType.name === 'Column Freezer') availableSizes = ['18 Inch', '24 Inch'];
      else if (selectedType.name === 'Column Refrigeration') availableSizes = ['24 Inch', '30 Inch'];
    }

    // Size
    html += renderFilterSelect('Size', true, selection.selectedSize,
      availableSizes, selection.selectedSize,
      `pbHandleSizeChange('${classId}', this.value)`, 'name');

    // Interior Finish & Door Type for Built In only
    if (selectedType?.name === 'Built In Refrigeration') {
      html += renderFilterSelect('Interior Finish (Optional)', false, true,
        options.interiorFinishes, selection.selectedInteriorFinishId,
        `pbHandleInteriorFinishChange('${classId}', this.value)`);

      html += renderFilterSelect('Door Type (Optional)', false, true,
        options.doorTypes, selection.selectedDoorTypeId,
        `pbHandleDoorTypeChange('${classId}', this.value)`);
    }

    // Finish
    html += renderFilterSelect('Finish', true, selection.selectedFinishId,
      options.finishes, selection.selectedFinishId,
      `pbHandleFinishChange('${classId}', this.value)`);

    // Accent (Optional)
    html += renderFilterSelect('Accent Finish (Optional)', false, true,
      options.accentFinishes, selection.selectedAccentFinishId,
      `pbHandleAccentFinishChange('${classId}', this.value)`);

    // Handle Type
    html += renderFilterSelect('Handle Type (Optional)', false, true,
      options.handleTypes, selection.selectedHandleTypeId,
      `pbHandleHandleTypeChange('${classId}', this.value)`);

    return html;
  }

  function renderMicrowavesFilters(options, selection, classId) {
    let html = '';

    // Microwave Type
    html += renderFilterSelect('Microwave Type', true, selection.selectedMicrowaveTypeId,
      options.microwaveTypes, selection.selectedMicrowaveTypeId,
      `pbHandleMicrowaveTypeChange('${classId}', this.value)`);

    const selectedType = selection.selectedMicrowaveTypeId ?
      options.microwaveTypes?.find(t => t.id === selection.selectedMicrowaveTypeId) : null;

    // Filter sizes
    let availableSizes = options.sizes;
    if (selectedType) {
      if (selectedType.name === 'Built In Microwave Oven' || selectedType.name === 'Built In Microwave Drawer') availableSizes = ['24 Inch', '30 Inch'];
      else if (selectedType.name === 'Over The Range Microwave') availableSizes = ['30 Inch'];
    }

    // Size
    html += renderFilterSelect('Size', true, selection.selectedSize,
      availableSizes, selection.selectedSize,
      `pbHandleSizeChange('${classId}', this.value)`, 'name');

    // Finish
    html += renderFilterSelect('Finish', true, selection.selectedFinishId,
      options.finishes, selection.selectedFinishId,
      `pbHandleFinishChange('${classId}', this.value)`);

    // Accent (Optional)
    html += renderFilterSelect('Accent Finish (Optional)', false, true,
      options.accentFinishes, selection.selectedAccentFinishId,
      `pbHandleAccentFinishChange('${classId}', this.value)`);

    // Handle Type
    html += renderFilterSelect('Handle Type (Optional)', false, true,
      options.handleTypes, selection.selectedHandleTypeId,
      `pbHandleHandleTypeChange('${classId}', this.value)`);

    return html;
  }

  function renderWallOvensFilters(options, selection, classId) {
    let html = '';

    // Number of Ovens
    html += renderFilterSelect('Number of Ovens', true, selection.selectedNumberOfOvensId,
      options.numberOfOvens, selection.selectedNumberOfOvensId,
      `pbHandleNumberOfOvensChange('${classId}', this.value)`);

    // Size (always 30 Inch for wall ovens)
    html += renderFilterSelect('Size', true, selection.selectedSize,
      ['30 Inch'], selection.selectedSize,
      `pbHandleSizeChange('${classId}', this.value)`, 'name');

    // Finish
    html += renderFilterSelect('Finish', true, selection.selectedFinishId,
      options.finishes, selection.selectedFinishId,
      `pbHandleFinishChange('${classId}', this.value)`);

    // Accent (Optional)
    html += renderFilterSelect('Accent Finish (Optional)', false, true,
      options.accentFinishes, selection.selectedAccentFinishId,
      `pbHandleAccentFinishChange('${classId}', this.value)`);

    // Handle Type
    html += renderFilterSelect('Handle Type (Optional)', false, true,
      options.handleTypes, selection.selectedHandleTypeId,
      `pbHandleHandleTypeChange('${classId}', this.value)`);

    return html;
  }

  function renderUnderCounterFilters(options, selection, classId) {
    let html = '';

    // Type
    html += renderFilterSelect('Type', true, selection.selectedUnderCounterTypeId,
      options.underCounterTypes, selection.selectedUnderCounterTypeId,
      `pbHandleUnderCounterTypeChange('${classId}', this.value)`);

    const selectedType = selection.selectedUnderCounterTypeId ?
      options.underCounterTypes?.find(t => t.id === selection.selectedUnderCounterTypeId) : null;

    // Filter sizes
    let availableSizes = options.sizes;
    if (selectedType) {
      if (selectedType.name === 'Ice Maker') availableSizes = ['15 Inch'];
      else availableSizes = ['24 Inch'];
    }

    // Size
    html += renderFilterSelect('Size', true, selection.selectedSize,
      availableSizes, selection.selectedSize,
      `pbHandleSizeChange('${classId}', this.value)`, 'name');

    // Finish
    html += renderFilterSelect('Finish', true, selection.selectedFinishId,
      options.finishes, selection.selectedFinishId,
      `pbHandleFinishChange('${classId}', this.value)`);

    // Accents (Optional)
    html += renderFilterSelect('Accents (Optional)', false, true,
      options.accentFinishes, selection.selectedAccentFinishId,
      `pbHandleAccentFinishChange('${classId}', this.value)`);

    return html;
  }

    function renderColumnRefrigeratorsFilters(options, selection, classId) {
    let html = '';

    // Column Refrigerator Type
    html += renderFilterSelect('Type', true, selection.selectedColumnRefrigeratorTypeId,
      options.columnRefrigeratorTypes, selection.selectedColumnRefrigeratorTypeId,
      `pbHandleColumnRefrigeratorTypeChange('${classId}', this.value)`);

    const selectedType = selection.selectedColumnRefrigeratorTypeId ?
      options.columnRefrigeratorTypes?.find(r => r.id === selection.selectedColumnRefrigeratorTypeId) : null;

    
    // Filter sizes based on type
    let availableSizes = options.sizes;
    if (selectedType) {
      if (selectedType.name === 'Column Wine' || selectedType.name === 'Column Freezer') availableSizes = ['18 Inch', '24 Inch'];
      else if (selectedType.name === 'Column Refrigeration') availableSizes = ['24 Inch', '30 Inch'];
    }

    // Size
    html += renderFilterSelect('Size', true, selection.selectedSize,
      availableSizes, selection.selectedSize,
      `pbHandleSizeChange('${classId}', this.value)`, 'name');

       // Panel Type
    html += renderFilterSelect('Panel Type', true, selection.selectedPanelTypeId,
      options.panelTypes, selection.selectedPanelTypeId,
      `pbHandlePanelTypeChange('${classId}', this.value)`);

    // Finish
    html += renderFilterSelect('Finish', false, true,
      options.finishes, selection.selectedFinishId,
      `pbHandleFinishChange('${classId}', this.value)`);

    // Accent (Optional)
    html += renderFilterSelect('Accent Finish (Optional)', false, true,
      options.accentFinishes, selection.selectedAccentFinishId,
      `pbHandleAccentFinishChange('${classId}', this.value)`);

    // Handle Type (Optional)
    html += renderFilterSelect('Handle Type (Optional)', false, true,
      options.handleTypes, selection.selectedHandleTypeId,
      `pbHandleHandleTypeChange('${classId}', this.value)`);

   

    return html;
  }

  function renderPlumbingFilters(options, selection, classId) {
    let html = '';

    // Plumbing Type (Kitchen or Bathroom)
    html += renderFilterSelect('Plumbing Type', true, selection.selectedPlumbingTypeId,
      options.plumbingTypes, selection.selectedPlumbingTypeId,
      `pbHandlePlumbingTypeChange('${classId}', this.value)`);

    // Get sub-types based on selected plumbing type
    const selectedPlumbingType = selection.selectedPlumbingTypeId ?
      options.plumbingTypes?.find(t => t.id === selection.selectedPlumbingTypeId) : null;

    let selectedProductTypeName = null;

    if (selectedPlumbingType && options.plumbingSubTypes) {
      const subTypes = options.plumbingSubTypes[selectedPlumbingType.name] || [];
      if (subTypes.length > 0) {
        const subTypeOptions = subTypes.map(name => ({
          id: name.split('').reduce((h, c) => ((h << 5) - h) + c.charCodeAt(0), 0),
          name: name
        }));
        html += renderFilterSelect('Product Type', true, selection.selectedPlumbingSubTypeId,
          subTypeOptions, selection.selectedPlumbingSubTypeId,
          `pbHandlePlumbingSubTypeChange('${classId}', this.value)`);

        // Find the selected product type name for finish filtering
        if (selection.selectedPlumbingSubTypeId) {
          // Convert to number for comparison in case it's stored as string
          const selectedId = parseInt(selection.selectedPlumbingSubTypeId);
          const selectedSubType = subTypeOptions.find(opt => opt.id === selectedId);
          if (selectedSubType) {
            selectedProductTypeName = selectedSubType.name;
          }
        }
      }
    }

    // Finish - only show if product type is selected, and use product-type-specific finishes
    if (selectedProductTypeName) {
      let finishNames = [];

      // Try to get product-type-specific finishes
      if (options.plumbingFinishesByProductType && options.plumbingFinishesByProductType[selectedProductTypeName]) {
        finishNames = options.plumbingFinishesByProductType[selectedProductTypeName];
      } else if (options.finishes && options.finishes.length > 0) {
        // Fallback to default plumbing finishes if mapping not found
        finishNames = options.finishes.map(f => f.name);
      }

      if (finishNames.length > 0) {
        const finishOptions = finishNames.map(name => ({
          id: name.split('').reduce((h, c) => ((h << 5) - h) + c.charCodeAt(0), 0),
          name: name
        }));
        html += renderFilterSelect('Finish', true, selection.selectedFinishId,
          finishOptions, selection.selectedFinishId,
          `pbHandleFinishChange('${classId}', this.value)`);
      }
    }

    return html;
  }

  /**
   * Validate filters for a category
   */
  function validateFilters(classId, options, selection) {
    let allSelected = false;
    let missing = [];

    if (classId === 'ranges') {
      allSelected = selection.selectedSize && selection.selectedFuelTypeId && selection.selectedFinishId;
      if (!selection.selectedSize) missing.push('Size');
      if (!selection.selectedFuelTypeId) missing.push('Fuel Type');
      if (!selection.selectedFinishId) missing.push('Finish');
    } else if (classId === 'hoods') {
      allSelected = selection.selectedSize && selection.selectedMountTypeId && selection.selectedFinishId;
      if (!selection.selectedSize) missing.push('Size');
      if (!selection.selectedMountTypeId) missing.push('Mount Type');
      if (!selection.selectedFinishId) missing.push('Finish');
    } else if (classId === 'dishwashers') {
      const selectedPanelType = selection.selectedPanelTypeId ? options.panelTypes?.find(p => p.id === selection.selectedPanelTypeId) : null;
      const requiresFinish = selectedPanelType && (selectedPanelType.name === 'Panel Included' || selectedPanelType.name === 'Dishwasher Panels');
      allSelected = selection.selectedSize && selection.selectedPanelTypeId && (!requiresFinish || selection.selectedFinishId);
      if (!selection.selectedSize) missing.push('Size');
      if (!selection.selectedPanelTypeId) missing.push('Panel Type');
      if (requiresFinish && !selection.selectedFinishId) missing.push('Finish');
    } else if (classId === 'refrigerators') {
      allSelected = selection.selectedSize && selection.selectedRefrigeratorTypeId && selection.selectedFinishId;
      if (!selection.selectedSize) missing.push('Size');
      if (!selection.selectedRefrigeratorTypeId) missing.push('Refrigerator Type');
      if (!selection.selectedFinishId) missing.push('Finish');
    } else if (classId === 'microwaves') {
      allSelected = selection.selectedSize && selection.selectedMicrowaveTypeId && selection.selectedFinishId;
      if (!selection.selectedSize) missing.push('Size');
      if (!selection.selectedMicrowaveTypeId) missing.push('Microwave Type');
      if (!selection.selectedFinishId) missing.push('Finish');
    } else if (classId === 'wall-ovens') {
      allSelected = selection.selectedSize && selection.selectedNumberOfOvensId && selection.selectedFinishId;
      if (!selection.selectedSize) missing.push('Size');
      if (!selection.selectedNumberOfOvensId) missing.push('Number of Ovens');
      if (!selection.selectedFinishId) missing.push('Finish');
    } else if (classId === 'rangetops') {
      allSelected = selection.selectedSize && selection.selectedRangetopTypeId && selection.selectedFinishId;
      if (!selection.selectedSize) missing.push('Size');
      if (!selection.selectedRangetopTypeId) missing.push('Type');
      if (!selection.selectedFinishId) missing.push('Finish');
    } else if (classId === 'under-counter-refrigeration') {
      allSelected = selection.selectedSize && selection.selectedUnderCounterTypeId && selection.selectedFinishId;
      if (!selection.selectedSize) missing.push('Size');
      if (!selection.selectedUnderCounterTypeId) missing.push('Type');
      if (!selection.selectedFinishId) missing.push('Finish');
    } else if (classId === 'column-refrigerators') {
      allSelected = selection.selectedSize && selection.selectedColumnRefrigeratorTypeId && selection.selectedPanelTypeId;
        if (!selection.selectedSize) missing.push('Size');
        if (!selection.selectedColumnRefrigeratorTypeId) missing.push('Type');
        if (!selection.selectedPanelTypeId) missing.push('Panel Type');
    } else if (classId === 'plumbing') {
      allSelected = selection.selectedPlumbingTypeId && selection.selectedPlumbingSubTypeId && selection.selectedFinishId;
      if (!selection.selectedPlumbingTypeId) missing.push('Plumbing Type');
      if (!selection.selectedPlumbingSubTypeId) missing.push('Product Type');
      if (!selection.selectedFinishId) missing.push('Finish');
    }

    return { allSelected, missing };
  }

  /**
   * Render filtered products for a category
   */
  function renderFilteredProducts(classId, state) {
    const categorySelection = state.selections.find(s => s.productClassId === classId);

    if (!categorySelection || !categorySelection.filteredProducts) {
      return '';
    }

    if (categorySelection.filteredProducts.length === 0) {
      return `
        <div style="margin-top: 20px; padding: 20px; text-align: center; color: #666; background: #f9f9f9; border-radius: 6px; border: 1px solid #d0d0d0;">
          <i class="fas fa-info-circle" style="font-size: 2rem; margin-bottom: 10px; color: #999;"></i>
          <p>No products found matching your selection.</p>
        </div>
      `;
    }

    return `
      <div style="margin-top: 20px;">
        <h4 style="margin-bottom: 15px; color: #1a1a1a; font-size: 1.1rem; font-weight: 700; padding: 12px 15px; background: #fff; border-left: 4px solid #c9a55a; border-radius: 4px;">Available Products</h4>
        <div class="pb-filtered-products">
          ${[...categorySelection.filteredProducts].sort((a, b) => {
            const aAuto = a.tags?.includes('Autograph Edition') ? 1 : 0;
            const bAuto = b.tags?.includes('Autograph Edition') ? 1 : 0;
            return aAuto - bAuto;
          }).map(product => renderProductCard(product, classId, state)).join('')}
        </div>
      </div>
    `;
  }

  /**
   * Render a single product card
   */
  function renderProductCard(product, classId, state) {
    const variant = product.variants[0];
    const hasPromoTag = product.tags?.some(tag => tag.toLowerCase() === 'promo');
    const hasPromo2Tag = product.tags?.some(tag => tag.toLowerCase() === 'promo 2');

    let mapPrice = null;
    let pmapPrice = null;

    if (window.PB_MAP_PRICES && window.PB_MAP_PRICES[product.id]) {
      const priceData = window.PB_MAP_PRICES[product.id];
      mapPrice = priceData.map ? parseFloat(priceData.map) : null;
      pmapPrice = priceData.pmap ? parseFloat(priceData.pmap) : null;
    }

    const displayPrice = pmapPrice || mapPrice || parseFloat(variant.price);
    const priceLabel = pmapPrice ? 'PMAP' : (mapPrice ? 'MAP' : 'Price');
    const dealerPrice = parseFloat(variant.price);

    const imageUrl = product.images[0]?.src || '';
    const isSelected = state.selections.find(s => s.productClassId === classId)?.selectedProducts?.some(p => p.id === product.id) || false;

    const productUrl = product.handle ? `/products/${product.handle}` : '#';
    const isAvailable = variant.available !== false;
    const stockStatus = isAvailable ? 'In Stock' : 'Out of Stock';
    const stockClass = isAvailable ? 'in-stock' : 'out-of-stock';

    const formattedDisplayPrice = displayPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const formattedDealerPrice = dealerPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    let priceDisplay = '';
    if (window.PB_CUSTOMER_LOGGED_IN) {
      priceDisplay = `
        <div class="pb-product-price">$${formattedDisplayPrice} <span style="font-size: 0.8rem; font-weight: 400;">${priceLabel}</span></div>
        <div class="pb-product-dealer-price" style="font-size: 1rem; font-weight: 700; color: #16a34a; margin-top: 4px;">$${formattedDealerPrice} <span style="font-size: 0.8rem; font-weight: 600;">Final Price</span></div>
      `;
    } else {
      priceDisplay = `<div class="pb-product-price">$${formattedDisplayPrice} <span style="font-size: 0.8rem; font-weight: 400;">${priceLabel}</span></div>`;
    }

    return `
      <div class="pb-product-card ${isSelected ? 'selected' : ''}">
        <img src="${imageUrl}" alt="${product.title}" class="pb-product-image" />
        <div class="pb-product-info">
          <div class="pb-product-sku">SKU: ${variant.sku || 'N/A'}</div>
          <div class="pb-product-title">${product.title}</div>
          ${priceDisplay}
          <div class="pb-stock-status ${stockClass}">${stockStatus}</div>
          ${hasPromo2Tag ? `<div class="pb-product-promo"><i class="fas fa-info-circle"></i> Promo 2 - MAP pricing for 6+ items</div>` : ''}
          ${hasPromoTag && !hasPromo2Tag ? `<div class="pb-product-promo"><i class="fas fa-info-circle"></i> On promotional pricing</div>` : ''}
          <div class="pb-product-actions">
            <a href="${productUrl}" target="_blank" class="pb-product-link" onclick="event.stopPropagation()">
              PRODUCT DETAILS <i class="fas fa-chevron-right"></i>
            </a>
            <button class="pb-add-product-btn" onclick="event.stopPropagation(); pbToggleProduct('${classId}', ${product.id})">
              ${isSelected ? '<i class="fas fa-check"></i> Added' : '<i class="fas fa-plus"></i> Add to Package'}
            </button>
          </div>
        </div>
      </div>
    `;
  }

  /**
   * Show/hide loading indicator
   */
  window.PB_showLoading = function(show) {
    document.getElementById('pbLoadingBar').classList.toggle('active', show);

    // Disable/enable interactive elements during loading
    const searchInput = document.getElementById('pbSearchInput');
    const searchBtn = document.querySelector('.pb-search-btn');
    const saveBtn = document.querySelector('.pb-save-cart-btn');
    const loadBtn = document.querySelector('.pb-load-cart-btn');
    if (searchInput) searchInput.disabled = show;
    if (searchBtn) searchBtn.disabled = show;
    if (saveBtn) saveBtn.disabled = show;
    if (loadBtn) loadBtn.disabled = show;
  };

  console.log('Package Builder UI loaded');
})();
